export class UserPermissions {
    userId;
    jwtToken;
    expirationToken;
    userRole;

    constructor(userId, jwtToken, expirationToken) {
        this.userId = userId;
        this.jwtToken = jwtToken;
        this.expirationToken = expirationToken;
        this.userRole = userRole
    }

    static setUserInfoToLocalStorage(userInfo) {
        localStorage.setItem('user-info', JSON.stringify(userInfo));
    }

    static getUserInfoFromLocalStorage() {
        return JSON.parse(localStorage.getItem('user-info'));
    }

    static removeUserInfoFromLocalStorage() {
        localStorage.removeItem('user-info');
    }
}


// WEBPACK FOOTER //
// ./src/utils/userInfo.js